import * as React from "react";
const InstallationView = React.lazy(() => import("./InstallationViewContainer"));

export { InstallationView };
